import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button } from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { ProcessLoader } from "../../ui/loader/processLoader";

let style = Object.assign({}, global);

const AdminEnableAuth = ({
  setShowModal,
  showModal,
  permissionAdminModalContent,
  setModalButtonClicked,
  isProcessing,
  isPopupOpen,
  showFailureMessage,
  userAlreadyLinked,
  setUserAlreadyLinked,
}) => {
  const close = () => {
    if (userAlreadyLinked) setUserAlreadyLinked(false);
    setShowModal(!showModal);
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    setModalButtonClicked({ type: type });
  };

  return (
    <React.Fragment>
      <h4 className={cx(style["fw-7"], style["mb-4"])}>{permissionAdminModalContent.modalHeader}</h4>

      <span aria-label="Close" className={cx(style["cross-modal"], style["rounded"])} onClick={close}>
        <Icon icon="ui-close" />
      </span>

      <div>
        <div
          className={cx(style["delete-msg"], style["font-base"], style["color-33"], [
            permissionAdminModalContent.modalButton && style["mb-4"],
          ])}>
          {permissionAdminModalContent.modalBody}
        </div>
        {permissionAdminModalContent.modalButton && (
          <div className={cx(style["d-flex"], style["align-items-center"])}>
            {!permissionAdminModalContent?.disabled ? (
              <Button
                type="submit"
                color="primary"
                onClick={e => handleSubmit(e, permissionAdminModalContent.type)}
                disabled={isProcessing || isPopupOpen}>
                {permissionAdminModalContent.modalButton}
              </Button>
            ) : (
              <Button outline disabled className={cx(style["bg-white"], style["cursor-not-allowed"], style["black"], style["border-dark"])}>
                {permissionAdminModalContent.modalButton}
              </Button>
            )}
            <ProcessLoader isOpen={isProcessing || isPopupOpen} wrapperClass={"ml-3"} />

            {!isPopupOpen && showFailureMessage && (
              <div className={cx(style["d-flex"], style["ml-3"], style["mt-2"])}>
                <span className={cx(style["icon"], style["mr-2"])}>
                  <Icon icon="ui-alert" />
                </span>
                <span>Please try again </span>
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

// AdminEnableAuth.propTypes = {
//   modalTitle: PropTypes.string.isRequired,
//   modalBody: PropTypes.string.isRequired,
//   modalButtonLabel: PropTypes.string.isRequired
// };

export default AdminEnableAuth;
